export default __webpack_public_path__ + "5ffd2c8.png";